import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/cuti-bersama/$year")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/en/joint-leave/${params.year}` } as any);
  },
  component: () => null,
});